import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import s from "./UpgradeNotification.css";

const UpgradeNotification = () => {
  return (
    <div className={s.upgradeContainer}>
      <div className={s.upgradeNotification}>
        <div className={s.upgradeBadge}>UPGRADE</div>
        <div className={s.upgradeHeadline}>Unlock Premium Access</div>
        <div className={s.upgradeText}>
          <span className={s.upgradeIcon}>⭐</span>
          Get all features on page refresh
        </div>
        <ul className={s.upgradeBenefits}>
          <li className={s.upgradeBenefitItem}>
            <span className={s.benefitIcon}>✔</span>
            Premium Support
          </li>
          <li className={s.upgradeBenefitItem}>
            <span className={s.benefitIcon}>✔</span>
            Full Access
          </li>
        </ul>
        <button className={s.upgradeButton}>
          <a target="_blank" href="https://www.aigrimm.com">
            Upgrade Now
          </a>
        </button>
        {/* <div className={s.upgradeLimited}>Limited-time offer</div> */}
      </div>
    </div>
  );
};

export default withStyles(s)(UpgradeNotification);
